import * as React from 'react';

export const useFileReader = (
  file: File,
): { isError: boolean; isLoading: boolean; image: { src: string; width: number; height: number } } => {
  const [isError, setIsError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [image, setImage] = React.useState({ src: '', width: 0, height: 0 });

  React.useEffect(() => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      const image = new Image();
      const src = typeof reader.result === 'string' ? reader.result : '';

      image.src = src;

      image.onload = () => {
        setImage({ src, width: image.width, height: image.height });
        setIsLoading(false);
      };
    };

    reader.onerror = () => {
      setIsLoading(false);
      setIsError(true);
    };
  }, [file]);

  return { isError, isLoading, image };
};
